<template>
  <v-container class="d-flex justify-center align-center flex-column" >
    <v-card flat max-width="500px">
      <v-card-title>
        Camera Bundle Order received!
      </v-card-title>
      <v-card-text>
<!--        <div style="width: 100%;" class="d-flex justify-center align-center" >-->
<!--          <v-icon color="accent" class="ma-3">mdi-rocket</v-icon>-->
<!--        </div>-->
        <p>We've received your request for the Camera equipment bundle!  The bundle has everything you need to get started shooting 360° video tours, including a 360° camera, tripod selfie stick, and sd card.</p>
        <p>We'll send you an email once the order has been placed.</p>
      </v-card-text>
      <v-card-actions>
        <v-btn block @click="goHome" color="primary">Okay</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "JustBoughtCamera",
  methods: {
    goHome() {
      this.$router.replace('home')
    }
  }
}
</script>

<style scoped>

</style>